import { Caption, useStyles } from '@archipro-design/aria';
import * as S from './NoSearchResults.style';

interface NoSearchResultsProps {
    resultsType: string;
}

export const NoSearchResults = ({ resultsType }: NoSearchResultsProps) => {
    const { css } = useStyles();

    const changeText =
        resultsType === 'articles' ? 'search term' : 'filters or search term';

    return (
        <div className={css(S.NoResults)}>
            <Caption variant="03-alt" weight="regular">
                {`Sorry, 0 ${resultsType} found.`}
            </Caption>

            <Caption variant="03-alt" weight="regular">
                {`Try changing the ${changeText}.`}
            </Caption>
        </div>
    );
};
